<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-03-20 14:11:16
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 17:14:31
-->
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2020-03-28 10:52:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-03-20 10:51:59
-->
<template>
  <div>
    <el-form
      :model="collectForm"
      ref="collectForm"
      label-width="100px"
      :rules="rules"
      :style="{ height: height }"
      class="demo-ruleForm base_setting"
    >
      <el-form-item label="问卷标题" prop="questionnaireTheme">
        <el-input
          v-model="collectForm.questionnaireTheme"
          placeholder="请输入问卷标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="问卷时间" prop="collectTime">
        <div class="block">
          <el-date-picker
            style="width: 100%"
            v-model="collectForm.collectTime"
            @input="changeTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期 时间"
            end-placeholder="结束日期 时间"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="发布单位" prop="questionnaireUnit">
        <el-input
          v-model="collectForm.questionnaireUnit"
          placeholder="请输入主办单位"
        ></el-input>
      </el-form-item>
      <el-form-item label="问卷时间" prop="issueTime">
        <div class="block">
          <el-date-picker
            v-model="collectForm.issueTime"
            style="width: 100%"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>
      </el-form-item>

      <el-form-item label="是否显示">
        <div class="status">
          <el-radio :disabled="!type" v-model="collectForm.displayStatus" :label="1"
            >显示 （需先完善问卷内容）</el-radio
          >
          <el-radio v-model="collectForm.displayStatus" :label="0"
            >不显示</el-radio
          >
        </div>
      </el-form-item>
      <el-form-item label="问卷说明">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          v-model="collectForm.questionnaireExplain"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div class="form-bottom base_btn">
      <el-button
        :loading="loadingSubmint"
        @click="saveCollect"
        v-if="codeData.indexOf('295') != -1"
        size="medium"
        type="primary"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import { saveCollect,collectDetils,updateCollect } from "../index";
import { message } from "ant-design-vue";
export default {
  components: {},
  data() {
    return {
      collectForm: {
        displayStatus:0,
      },
      height: "",
      loadingSubmint: false,
      type:0,
      codeData:[],
      isCollectId: sessionStorage.getItem('wenjuanCollectId') || this.$route.query.isCollectId || 0,
      rules: {
        questionnaireUnit: [
          { required: true, message: "请输入发布单位", trigger: "blur" },
        ],
        questionnaireTheme: [
          { required: true, message: "请输入问卷标题", trigger: "blur" },
        ],
        collectTime: [
          { required: true, message: "请输入问卷时间", trigger: "blur" },
        ],
        issueTime: [
          { required: true, message: "请输入发布时间", trigger: "blur" },
        ],
      },
    };
  },

  mounted() {
    if(this.isCollectId){
       this.getCollectDetils();
    }
     this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
      this.height = document.documentElement.clientHeight - 320 + 'px';
      window.onresize = () => {
      return (() => {
          this.height = document.documentElement.clientHeight - 320 + 'px';
      })();
    };
  },
  methods: {
    //保存征集数据
    changeTime(){
      this.collectForm = JSON.parse(JSON.stringify(this.collectForm ))
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    getCollectDetils() {
      collectDetils({ id: this.isCollectId }).then((res) => {
        if (res.code == 0) {
          this.collectForm = res.data;
          this.type = res.data.type;
          this.collectForm.collectTime = [
            new Date(this.collectForm.questionnaireStartTime),
            new Date(this.collectForm.questionnaireEndTime),
          ];
        }
      });
    },
    saveCollect() {
      this.$refs.collectForm.validate((valid) => {
        if (valid) {
          const _this = this;
          this.loadingSubmint = true;
          let reqData = { ..._this.collectForm };
          if (reqData.questionnaireStartTime) {
            reqData.questionnaireStartTime = _this.farmatDate(
              new Date(_this.collectForm.collectTime[0].toString()).getTime(),
              "-"
            );
          }
          if (reqData.questionnaireEndTime) {
            reqData.questionnaireEndTime = _this.farmatDate(
              new Date(_this.collectForm.collectTime[1].toString()).getTime(),
              "-"
            );
          }

          if (typeof _this.collectForm.issueTime != "string") {
            if (reqData.issueTime) {
              reqData.issueTime = _this.farmatDate(
                new Date(_this.collectForm.issueTime.getTime()),
                "-"
              );
            }
          }
          reqData.siteId = sessionStorage.getItem("siteId");
          if (this.isCollectId) {
            updateCollect(reqData).then((res) => {
              if (res.code == 0) {
                message.success(res.msg);
                _this.getCollectDetils();
                _this.loadingSubmint = false;
              }
            });
          } else {
            if (reqData.collectTime) {
              reqData.questionnaireStartTime = _this.farmatDate(
                new Date(reqData.collectTime[0].toString()).getTime(),
                "-"
              );

              reqData.questionnaireEndTime = _this.farmatDate(
                new Date(reqData.collectTime[1].toString()).getTime(),
                "-"
              );
              delete reqData.collectTime;
            }
            saveCollect(reqData).then((res) => {
              if (res.code == 0) {
                _this.isCollectId = res.data.id;
                sessionStorage.setItem('wenjuanCollectId',_this.isCollectId)
                this.$emit('content')
                message.success(res.msg);
                _this.getCollectDetils();
                _this.loadingSubmint = false;
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  padding: 24px;
  .log-box {
    border-bottom: solid 1px #dcdfe6;
    display: flex;
    color: #000;
    .log {
      padding: 10px 20px;
      border-top: solid 1px #dcdfe6;
      border-left: solid 1px #dcdfe6;
      cursor: pointer;
    }
    .log:last-child {
      border-right: solid 1px #dcdfe6;
      border-top-right-radius: 10px;
    }
    .log:first-child {
      border-top-left-radius: 10px;
    }
  }
}
.head {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dcdfe6;
  padding: 18px 24px;
}
.content {
  padding-left: 24px;
  .demo-ruleForm {
    width: 600px;
    padding-left: 24px;
  }
  .tips-text {
    font-size: 12px;
    // height: 20px;
    line-height: 26px;
    color: #9093a6;
  }
  /deep/ .el-form-item__label {
    text-align: left;
    width: 100px !important;
  }
  /deep/ .el-form-item__content {
    margin-left: 100px !important;
  }
  /deep/ .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
    border: none;
    img {
      width: 80px;
      height: 80px;
    }
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }
  /deep/.el-button {
    line-height: 0;
  }
  .status {
    border: solid 1px #dcdfe6;
    border-radius: 4px;
    padding-left: 10px;
  }
}
.choose_template {
  /deep/.el-dialog__title {
    font-size: 16px;
    font-weight: bold;
  }
  /deep/.el-dialog {
    width: 36%;
  }
  .lod-tips {
    background: #f7f7f7;
    font-size: 12px;
    color: #928f8f;
    line-height: 36px;
    padding: 0 10px;
    border-radius: 4px;
  }
  .choose-path {
    line-height: 50px;
    padding: 0 10px;
    border-radius: 4px;
    border: solid 1px #dcdfe6;
    margin-top: 20px;
    box-sizing: border-box;
  }
  .template-list {
    border: solid 1px #dcdfe6;
    border-radius: 4px;
    margin-top: 20px;

    .title {
      background: #f7f7f7;
    }
    .item {
      font-weight: bold;
      line-height: 52px;
      box-sizing: border-box;
      border-bottom: solid 1px #dcdfe6;
      padding: 0 10px;
      &:last-child {
        border: none;
      }
    }
  }
}
.add-uplaod {
  width: 43px;
  height: 40px;
  background-color: #f6f6f6;
  border-radius: 4px;
  text-align: center;
  border: 1px solid #dcdfe6;
  margin-left: 10px;
}
.edit-image {
  position: absolute;
  background: #858383;
  width: 50%;
  height: 30px;
  line-height: 30px;
  margin: 0 auto;
  border-radius: 5px;
  cursor: pointer;
  bottom: 8px;
  right: 25%;
  // margin-left: -30px;
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.semi-close {
  position: absolute;
  top: -8px;
  right: -7px;
  width: 20px;
  height: 20px;
  background-color: rgba(144, 147, 153, 1);
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-box {
  position: relative;
  width: 154px;
  height: 120px;
  margin-top: 20px;
  margin-right: 20px;
  .add-img {
    width: 100%;
    height: 100%;
  }
}
.img-arry {
  display: flex;
}
.back {
  cursor: pointer;
}
.written-transcript {
  display: flex;
  .left {
    flex: 1;
    .written-content {
      border-radius: 2px;
      background-color: rgba(247, 247, 249, 1);
      color: rgba(16, 16, 16, 1);
      font-size: 14px;
      padding: 14px;
      margin-top: 14px;
    }
  }
  .right {
    width: 462px;
    background: #fff;
    margin-left: 24px;
    margin-right: 24px;
    border: solid 2px #d9d9d9;
    border-radius: 6px;
  }
}
.written-title {
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 20px;
}
.written-one {
  display: flex;
  justify-content: space-between;
  .written-name {
    display: flex;
  }
}
/deep/ .el-timeline-item__icon {
  color: #fff;
  font-size: 18px;
  background: #fff;
}
/deep/ .el-timeline-item__node--normal {
  left: -1px;
  top: -7px;
}
.right-title {
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  border-radius: 6px 6px 0px 0px;
  background-color: rgba(247, 247, 247, 1);
  height: 56px;
  line-height: 56px;
  padding-left: 18px;
  border-bottom: solid 2px #d9d9d9;
  font-weight: 600;
}
/deep/ .el-timeline {
  padding-left: 0px;
}
.add-input {
  padding: 24px;
}
.reacod-style {
  border-radius: 20px;
  background-color: rgba(245, 247, 250, 1);
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(220, 223, 230, 1);
  padding: 7px 16px 7px 10px;
  max-width: 154px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  margin-right: 12px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  .icon-field-close:before {
    color: #a9aab1;
    font-size: 18px;
    margin-left: 20px;
  }
}
.box-reacod {
  display: flex;
  padding: 0 24px;
  flex-wrap: wrap;
}
.record-data {
  padding: 20px 24px;
  border-radius: 2px;
  padding-bottom: 1px;
  background-color: rgba(247, 247, 249, 1);
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  /deep/ .el-form-item__label {
    width: 80px !important;
  }
  /deep/ .el-form-item__content {
    margin-left: 81px !important;
  }
  /deep/ .el-select {
    width: 100%;
  }
}
.fayan {
  /deep/ .el-textarea__inner {
    border: none !important;
    resize: none;
    outline: none;
  }
}
.btn {
  margin-bottom: 24px;
  margin-right: 24px;
  text-align: right;
}
.time-style {
  display: flex;
  border: solid 1px rgba(220, 223, 230, 1);
  /deep/ .el-input__inner {
    outline: none;
    border: none;
  }
}
.add-time {
  border-radius: 0px 4px 4px 0px;
  background-color: rgba(245, 247, 250, 1);
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  height: 100%;
  text-align: center;
  font-family: Roboto;
  border-left: 1px solid rgba(220, 223, 230, 1);
  width: 100px;
  cursor: pointer;
}
.base_setting {
  width: 800px;
  overflow-y: auto;
  padding: 24px;
}
.base_btn {
  position: relative;
  bottom: 0;
  padding: 24px;
  padding-left: 124px;
  padding-top: 20px;
}
.el-button--primary {
  background: #176de6;
}
</style>